import PropTypes from "prop-types";
import React from "react";

import Icon from "../../components/interface/Icon";

const PrintPreviewPdfNavigation = props => {
  const { pageNumber, numPages } = props;

  const text = numPages ? `Page ${pageNumber} of ${numPages}` : `Page ${pageNumber}`;

  const canGoPrev = pageNumber > 1;
  const canGoNext = pageNumber < numPages;

  return (
    <div className="pdfNavigation">
      <Icon
        icon="leftArrow"
        onClick={canGoPrev ? props.onPrevClick : null}
        color={canGoPrev ? "iconBold" : "iconFade"}
      />
      <span>{text}</span>
      <Icon
        icon="rightArrow"
        onClick={canGoNext ? props.onNextClick : null}
        color={canGoNext ? "iconBold" : "iconFade"}
      />
    </div>
  );
};

PrintPreviewPdfNavigation.propTypes = {
  pageNumber: PropTypes.number,
  numPages: PropTypes.number,
  onPrevClick: PropTypes.func,
  onNextClick: PropTypes.func
};

export default PrintPreviewPdfNavigation;
